// API Configuration - Use Firebase Functions for production, local backend for development
// Always use Firebase Functions in production (hosted on Firebase Hosting)
// Check if we're on the production domain or if NODE_ENV is production
const getIsProduction = () => {
  if (process.env.NODE_ENV === 'production') return true;
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return hostname.includes('gearcompare-49e60.web.app') ||
           hostname.includes('gearcompare-49e60.firebaseapp.com') ||
           hostname.includes('studiogearcompare.com') ||
           hostname === 'studiogearcompare.com' ||
           hostname === 'www.studiogearcompare.com';
  }
  return false;
};

const isProduction = getIsProduction();
const USE_FIREBASE = isProduction; // Use Firebase Functions in production
const USE_FIREBASE_FOR_ARTICLES = isProduction; // Use Firebase Functions for articles in production
const USE_FIREBASE_FOR_EQUIPMENT = isProduction; // Use Firebase Functions for equipment in production
const USE_FIREBASE_FOR_MYSTUDIO = isProduction; // Use Firebase Functions for MyStudio in production
const USE_FIREBASE_FOR_ADMIN = isProduction; // Use Firebase Functions for admin in production
const USE_MOCK_FALLBACK = false; // No fallback needed

export const apiConfig = {
  useFirebase: USE_FIREBASE,
  useFirebaseForArticles: USE_FIREBASE_FOR_ARTICLES,
  useFirebaseForEquipment: USE_FIREBASE_FOR_EQUIPMENT,
  useFirebaseForMyStudio: USE_FIREBASE_FOR_MYSTUDIO,
  useFirebaseForAdmin: USE_FIREBASE_FOR_ADMIN,
  // Updated to use europe-west1 region (matches Firestore and Functions deployment)
  baseURL: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api' : (process.env.REACT_APP_API_URL || 'http://localhost:5001/api'),
  endpoints: {
    articles: USE_FIREBASE_FOR_ARTICLES ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/articles' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/articles`,
    equipment: USE_FIREBASE_FOR_EQUIPMENT ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/equipment' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/equipment`,
    users: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/users' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/users`,
    songs: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/songs' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/songs`,
    audio: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/audio' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/audio`,
    audioFiles: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/audio-files' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/audio-files`,
    fileTypes: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/file-types' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/file-types`,
    comparison: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/comparison' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/comparison`,
    admin: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/admin' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin`,
    images: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/images' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/images`,
    ratings: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/ratings' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/ratings`,
    comparisonLogs: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/comparison-logs' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/comparison-logs`,
    featuredEquipment: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/featured-equipment' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/featured-equipment`,
    csvImport: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/csv-import' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/csv-import`,
    articleComments: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/article-comments' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/article-comments`,
    upload: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/upload' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/upload`,
    firebaseUpload: USE_FIREBASE ? 'https://europe-west1-gearcompare-49e60.cloudfunctions.net/api/api/firebase-upload' : `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/firebase-upload`
  }
};

// Debug logging (always log in production to help debug domain issues)
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  console.log('🔍 API Configuration loaded:');
  console.log('  Hostname:', hostname);
  console.log('  NODE_ENV:', process.env.NODE_ENV);
  console.log('  USE_FIREBASE:', USE_FIREBASE);
  console.log('  USE_FIREBASE_FOR_ARTICLES:', USE_FIREBASE_FOR_ARTICLES);
  console.log('  USE_FIREBASE_FOR_EQUIPMENT:', USE_FIREBASE_FOR_EQUIPMENT);
  console.log('  USE_FIREBASE_FOR_MYSTUDIO:', USE_FIREBASE_FOR_MYSTUDIO);
  console.log('  USE_FIREBASE_FOR_ADMIN:', USE_FIREBASE_FOR_ADMIN);
  console.log('  isProduction:', isProduction);

  if (USE_FIREBASE) {
    console.log('🔥 Using Firebase services for all API calls');
    console.log('  Base URL:', apiConfig.baseURL);
  } else {
    console.log('🖥️ Using PostgreSQL backend API for everything');
    console.warn('⚠️ WARNING: Not using Firebase - API calls may fail!');
  }
}

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  // Always use Firebase Functions if we're in production or on production domain
  // Ignore REACT_APP_API_URL in production to prevent localtunnel/local URLs
  const shouldUseFirebase = USE_FIREBASE || (typeof window !== 'undefined' && (() => {
    const hostname = window.location.hostname;
    return hostname.includes('gearcompare-49e60.web.app') || 
           hostname.includes('gearcompare-49e60.firebaseapp.com') || 
           hostname.includes('studiogearcompare.com') ||
           hostname === 'studiogearcompare.com' ||
           hostname === 'www.studiogearcompare.com';
  })());
  
  if (shouldUseFirebase) {
    // Updated to use europe-west1 region (matches Firestore and Functions deployment)
    // Firebase Functions Express app is mounted at /api, so endpoint should be /firebase-upload/image (not /api/firebase-upload/image)
    // The endpoint already includes the /api prefix in the Express routes
    const url = `https://europe-west1-gearcompare-49e60.cloudfunctions.net/api${endpoint}`;
    if (process.env.NODE_ENV === 'development') {
      console.log('🔗 API URL:', url);
    }
    return url;
  }
  const localUrl = `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}${endpoint}`;
  console.warn('⚠️ Using local API URL:', localUrl);
  return localUrl;
};

// Helper function to get base URL for static files (uploads)
export const getStaticUrl = () => {
  if (USE_FIREBASE) {
    // When using Firebase, return Firebase Storage base URL
    return 'https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app';
  }
  const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001/api').replace('/api', '');
  return baseUrl;
};

// Helper function to get the correct URL for images/files
export const getImageUrl = (url) => {
  if (!url) return '';
  
  // If URL is already a full URL (starts with http), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // For brand logos (in /images/ or /uploads/brands/), always use Firebase Storage
  // Brand logos are uploaded to the 'images' folder via ImageUpload component
  // Check if URL contains 'images/' (with or without leading slash) or firebasestorage
  if (url.includes('images/') || url.includes('/images/') || url.includes('/uploads/brands/') || url.includes('/uploads/equipment/') || url.includes('firebasestorage')) {
    // If URL already starts with http, return as-is (already a full URL)
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    const firebaseBaseUrl = 'https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app';
    // If URL doesn't start with '/', add it
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    return `${firebaseBaseUrl}${normalizedUrl}`;
  }
  
  // For studio photos (in /studio-photos/ or /uploads/studio-photos/), always use Firebase Storage
  if (url.includes('/studio-photos/') || url.includes('/uploads/studio-photos/')) {
    const firebaseBaseUrl = 'https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app';
    return `${firebaseBaseUrl}${url}`;
  }
  
  // For banner images, always use Firebase Storage
  // Handle both '/uploads/banners/' and 'uploads/banners/' (with or without leading slash)
  if (url.includes('uploads/banners/') || url.includes('banners/')) {
    const firebaseBaseUrl = 'https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app';
    // If URL already starts with http, return as-is (already a full URL)
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    // If URL doesn't start with '/', add it
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    const fullUrl = `${firebaseBaseUrl}${normalizedUrl}`;
    console.log('🔍 getImageUrl: Banner image conversion:', { original: url, normalized: normalizedUrl, full: fullUrl });
    return fullUrl;
  }
  
  // For audio files, always use Firebase Storage
  if (url.includes('/uploads/audio/') || url.includes('uploads/audio/')) {
    const firebaseBaseUrl = 'https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app';
    // If URL already starts with http, return as-is (already a full URL)
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    // If URL doesn't start with '/', add it
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    return `${firebaseBaseUrl}${normalizedUrl}`;
  }
  
  // For other images, use environment-appropriate URL
  return `${getStaticUrl()}${url}`;
};

// Helper function to get the correct URL for audio files
// If audioFileId is provided, use the serve endpoint with ID (preferred)
// Otherwise, try to construct URL from path
export const getAudioUrl = (url, audioFileId = null) => {
  if (!url && !audioFileId) return '';
  
  // If URL is already a full URL (starts with http), return as-is
  if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
    return url;
  }
  
  // If we have an audio file ID, use the serve endpoint (preferred method)
  // This should always be used when we have an ID, regardless of the path
  if (audioFileId != null && audioFileId !== '') {
    return getApiUrl(`/audio-files/${audioFileId}/serve`);
  }
  
  // Try Firebase Storage first (for files that have been migrated)
  // If the file path suggests it's in Firebase Storage, use Firebase Storage URL
  if (url && (url.includes('firebasestorage.app') || (USE_FIREBASE && url.startsWith('/uploads/')))) {
    const firebaseBaseUrl = 'https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app';
    // Convert /uploads/audio/ to /audio/ for Firebase Storage
    let normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    if (normalizedUrl.includes('/uploads/audio/')) {
      normalizedUrl = normalizedUrl.replace('/uploads/audio/', '/audio/');
    }
    return `${firebaseBaseUrl}${normalizedUrl}`;
  }
  
  // For local files without ID, try Firebase Storage (might work if files were migrated)
  if (url) {
    const firebaseBaseUrl = 'https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app';
    // Convert /uploads/audio/ to /audio/ for Firebase Storage
    let normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    if (normalizedUrl.includes('/uploads/audio/')) {
      normalizedUrl = normalizedUrl.replace('/uploads/audio/', '/audio/');
    }
    return `${firebaseBaseUrl}${normalizedUrl}`;
  }
  
  return '';
};

// Mock data for production when backend is not available
export const mockData = {
  equipment: [
    {
      id: 1,
      name: "1176LN Limiting Amplifier",
      brand: "Universal Audio",
      category: "compressor",
      type: "hardware",
      description: "The 1176LN is a classic FET compressor known for its fast attack times and musical compression characteristics.",
      image_urls: ["https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app/images/image-1759646279293-714621532.jpg"],
      price_range: "$2,000 - $3,000",
      features: ["FET compression", "Fast attack times", "Classic sound"],
      use_cases: ["Vocal compression", "Drum compression", "Mix bus compression"],
      popular_users: ["Chris Lord-Alge", "Bob Clearmountain", "Andy Wallace"]
    },
    {
      id: 2,
      name: "LA-2A Leveling Amplifier",
      brand: "Universal Audio",
      category: "compressor",
      type: "hardware",
      description: "The LA-2A is an optical compressor known for its smooth, musical compression and warm tube sound.",
      image_urls: ["https://example.com/la2a.jpg"],
      price_range: "$2,500 - $3,500",
      features: ["Optical compression", "Tube amplification", "Smooth compression"],
      use_cases: ["Vocal leveling", "Bass compression", "Mix bus compression"],
      popular_users: ["Al Schmitt", "Bruce Swedien", "Tom Dowd"]
    },
    {
      id: 3,
      name: "API 550A Equalizer",
      brand: "API",
      category: "eq",
      type: "hardware",
      description: "The 550A is a 3-band equalizer with fixed frequencies, known for its musical sound and API's signature tone.",
      image_urls: ["https://storage.googleapis.com/gearcompare-49e60.firebasestorage.app/images/image-1759783366819-273168909.avif"],
      price_range: "$1,500 - $2,000",
      features: ["3-band EQ", "Fixed frequencies", "API sound"],
      use_cases: ["Mix EQ", "Tracking EQ", "Mastering EQ"],
      popular_users: ["Eddie Kramer", "Andy Johns", "Glyn Johns"]
    }
  ],
  audioFiles: [
    {
      id: 1,
      file_name: "HOLD Piano Stem.wav",
      file_path: "/uploads/audio/audio-1759187540255-531177406.wav",
      duration: 180.5,
      sample_rate: 44100,
      bit_depth: 24,
      channels: 2
    },
    {
      id: 2,
      file_name: "HOLD Big Brass Stem.wav", 
      file_path: "/uploads/audio/audio-1759187561879-305362520.wav",
      duration: 180.5,
      sample_rate: 44100,
      bit_depth: 24,
      channels: 2
    },
    {
      id: 3,
      file_name: "HOLD Lead Dry Stem.wav",
      file_path: "/uploads/audio/audio-1759187575834-519886291.wav", 
      duration: 180.5,
      sample_rate: 44100,
      bit_depth: 24,
      channels: 2
    }
  ]
};

export default apiConfig;